import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Material UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Pagination from '@mui/material/Pagination';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';
import { Tooltip, Chip } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp'
import Button from '@mui/material/Button';
import FilterListIcon from "@mui/icons-material/FilterList";
import { createFilterOptions } from '@mui/material/Autocomplete';
// Hooks
import useSearchProducts from '../../hooks/searchProducts/useSearchProducts';
import useUser from '../../hooks/user/useUser';
import useCategories from '../../hooks/category/useCategories';
import useCart from '../../hooks/orders/CartProvider';

// Components
import Autocomplete from '../../components/inputs/Autocomplete';
import Item from './item';
import Modal from '../modal';
import Searchbox from '../inputs/searchbox';
import SearchProductModal from './modal';
import useNotify from '../../hooks/notify';
import ModalScanner from '../modalEscanner';
import useStyles from './styles';
import TextField from '../inputs/input';
import useDistressedCategories from '../../hooks/category/useDistressedCategories';
import { FabContainer } from '@arredo/reactjs-ui';


const SearchProduct = ({ shoppingMode, onAddItem, onRemoveItem, onSetItems }) => {
    const { classes } = useStyles();
    const { categories, findChildren, GetPath, ChangeTextFilter } = useCategories();
    const { distressedCategories, findChildren: findDistressedChildren, GetPath: GetDistressedPath, ChangeTextFilter: ChangeDistressedTextFilter } = useDistressedCategories();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedDistressedCategories, setSelectedDistressedCategories] = useState([]);

    const { searchProducts, loading, totalPage, filters, setFilters, exportProducts, exportLoading } = useSearchProducts();
    const [variant, setVariant] = useState(null);
    const [product, setProduct] = useState(null);
    const [colorSelected, setColorSelected] = useState('');
    const [code, setCode] = useState('');
    const [selectedRefId, setSelectedRefId] = useState('');
    const { branch } = useUser();
    const [withStockInBranch, setWithStockInBranch] = useState(true);
    const { Notify, variants } = useNotify();
    const [openModal, setOpenModal] = useState(false);
    const { existProcessedPayment } = useCart();

    const handleCategoryAutocompleteInputChange = (event, value, isDistressed = false) => {
        if (!!value.length && value.length > 2) isDistressed ? ChangeDistressedTextFilter(value) : ChangeTextFilter(value);
    }

    const handleCategoryAutocompleteChange = async (event, options, action, arg, isDistressed = false) => {
        if (action === "select-option") {
            arg.option.children = isDistressed ? await findDistressedChildren(arg.option) : await findChildren(arg.option);
        }

        if (isDistressed) {
            setSelectedDistressedCategories(options.map(s => s));
            setFilters({ distressedCategoryIds: [...new Set(options.map(c => c.id))] })
        } else {
            setSelectedCategories(options.map(s => s));
            setFilters({ categoryIds: [...new Set(options.map(c => c.id))] })
        }
    }

    const handleChangePage = (e, page) => {
        setFilters({ ...filters, page: Number(page) });
    }

    const handleFilterChange = (event) => {
        setCode('');
        setFilters({
            [event.target.name]: event.target.value,
            code: ''
        });
    }

    const handleShowDescription = (productChange, variant) => {
        setProduct(productChange);
        setVariant(variant)
    }

    const handleClickExport = async () => {
        if (!branch.priceListId)
            return Notify(`El branch '${branch.name}' no posee una lista de precios asociada`, variants.ERROR)

        exportProducts()
    }

    const handleClickEscaner = async () => {
        setOpenModal(true);
    }

    const RefIdToArray = (refId) =>
        refId.split('%');

    const handleCodeChange = (event) => {
        const value = event.target.value.toUpperCase(); // Mayúsculas
        // value = value.replace(/[^A-Za-z0-9%]/g, ""); // Sin caracteres especiales excepto '%'
        // value = value.replace(/(?<=%.*)%/g, ''); // Sólo '%' una vez
        setCode(value);

        if (shoppingMode) {
            const [, color] = RefIdToArray(value)
            setColorSelected(color || '')
            setFilters({ [event.target.name]: value });
        }
    }

    const handleInputKeyUp = (event) => {
        if ((event.keyCode === 13 || event.code === 'Enter') && code) {
            const [, color] = RefIdToArray(code)
            setSelectedRefId(code);
            setColorSelected(color || '')
            setFilters({ [event.target.name]: code });
            setCode('')
        }
    }

    const handleClearFilter = () => {
        setFilters({ code: '', searchData: '', categoryIds: null, distressedCategoryIds: null, withStockInBranch: true });
        setCode('');
        setSelectedCategories([]);
        setSelectedDistressedCategories([]);
    }

    const handleSwitchChange = async (event) => {
        setFilters({
           [event.target.name]: event.target.checked,
        });
        setWithStockInBranch(event.target.checked);
    }

    return (
        <>
            {
                variant &&
                <SearchProductModal
                    open={!!variant}
                    variant={variant}
                    product={product}
                    onClose={() => setVariant(null)}
                />
            }
            {
                openModal &&
                <ModalScanner
                    open={openModal}
                    onSave={onSetItems}
                    onClose={() => setOpenModal(false)}
                />
            }
            <Modal
                fullWidth
                disableEscapeKeyDown
                fullScreen={false}
                open={exportLoading}
            >
                <Grid container direction='column' alignItems='center' spacing={1}>
                    <Grid>
                        <CircularProgress />
                    </Grid>
                    <Grid>
                        <Typography variant='h5'>Generando el archivo de Excel</Typography>
                    </Grid>
                </Grid>
            </Modal>
            {!existProcessedPayment &&
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={2}>
                                {shoppingMode ? (
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 4,
                                            lg: 3
                                        }}
                                    >
                                        <Searchbox
                                            fullWidth
                                            size='small'
                                            name="code"
                                            label="Filtrar por código"
                                            onChange={handleCodeChange}
                                            value={code}
                                            placeholder='Ej.: 10003F39999%U'
                                            interval={800}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 4,
                                            lg: 3
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            autoFocus
                                            name='code'
                                            label='Filtrar por código'
                                            size='small'
                                            value={code}
                                            onChange={handleCodeChange}
                                            onKeyUp={handleInputKeyUp}
                                            placeholder='Ej.: 10003F39999%U'
                                            helperText="Presiona 'Enter' para ingresar el codigo"
                                        />
                                    </Grid>
                                )}
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 8,
                                        lg: 4
                                    }}
                                >
                                    <Searchbox
                                        fullWidth
                                        size='small'
                                        name='searchData'
                                        label='Filtrar por texto'
                                        onChange={handleFilterChange}
                                        value={filters?.searchData?.toString() || ''}
                                        placeholder='Ej.: almohada'
                                    />
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 6,
                                        lg: 5
                                    }}
                                >
                                    <Autocomplete
                                        fullWidth
                                        multiple
                                        limitTags={2}
                                        size='small'
                                        options={distressedCategories}
                                        loading={loading}
                                        loadingText='Estrategia de uso...'
                                        value={selectedDistressedCategories}
                                        getOptionLabel={(option) => option.description}
                                        onInputChange={(e, v) => handleCategoryAutocompleteInputChange(e, v, true)}
                                        onChange={(event, options, action, arg) => handleCategoryAutocompleteChange(event, options, action, arg, true)}
                                        TextProps={{
                                            label: 'Estrategia de uso',
                                            placeholder: 'Ej.: Discontinuo',
                                        }}
                                        filterOptions={createFilterOptions({
                                            stringify: (option) => option.description + option.path,
                                        })}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <span>{option.path}</span>
                                            </li>)}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Tooltip key={index} title={GetDistressedPath(option)}>
                                                    <Chip label={option.description} {...getTagProps({ index })} />
                                                </Tooltip>
                                            ))
                                        }
                                    />
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 6
                                    }}
                                >
                                    <Autocomplete
                                        fullWidth
                                        limitTags={3}
                                        multiple
                                        size='small'
                                        options={categories}
                                        loading={loading}
                                        loadingText='Buscando categorias...'
                                        value={selectedCategories}
                                        getOptionLabel={(option) => option.description}
                                        onInputChange={(e, v) => handleCategoryAutocompleteInputChange(e, v)}
                                        onChange={(event, options, action, arg) => handleCategoryAutocompleteChange(event, options, action, arg)}
                                        TextProps={{
                                            label: 'Categoría',
                                            placeholder: 'Ej.: Dormitorio',
                                        }}
                                        filterOptions={createFilterOptions({
                                            stringify: (option) => option.description + option.path,
                                        })}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <span>{option.path}</span>
                                            </li>)}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Tooltip key={index} title={GetPath(option)}>
                                                    <Chip label={option.description} {...getTagProps({ index })} />
                                                </Tooltip>
                                            ))
                                        }
                                    />
                                </Grid>
                                {
                                    !shoppingMode && (
                                    <Box component={Grid} item xs={12} sm={6} display='flex' alignItems='center'>
                                        <Typography>Con stock</Typography>
                                        <Switch
                                            color='primary'
                                            name='withStockInBranch'
                                            onChange={handleSwitchChange}
                                            checked={withStockInBranch}
                                            disabled={false}
                                        />
                                    </Box> 
                                )}
                                {shoppingMode
                                    ? <Box component={Grid} item xs={12} sm display='flex' flexGrow={1} justifyContent='flex-end'>
                                        <Button
                                            fullWidth
                                            color='primary'
                                            variant="outlined"
                                            onClick={handleClickEscaner}
                                        >
                                            Escaner
                                        </Button>
                                    </Box>
                                    : <Box component={Grid} item xs={12} sm display='flex' flexGrow={1} justifyContent='flex-end'>
                                        <Button
                                            color="primary"
                                            variant="outlined"
                                            onClick={handleClearFilter}
                                            startIcon={<FilterListIcon />}
                                        >
                                            Limpiar
                                        </Button>
                                    </Box>
                                }
                            </Grid>
                        </Paper>
                    </Grid>
                    {loading &&
                        <Box
                            component={Grid}
                            size={12}
                            display='flex'
                            flexDirection='column'
                            alignContent='center'
                            alignItems='center'
                        >
                            <CircularProgress />
                            <Typography variant='h5'>
                                Buscando productos...
                            </Typography>
                        </Box>
                    }
                    {!loading &&
                        <>
                            {
                                searchProducts &&
                                searchProducts.map((product, index) =>
                                    <Grid
                                        key={index}
                                        size={{
                                            xs: 12,
                                            sm: 6,
                                            lg: shoppingMode ? 3 : 2.4,
                                            xl: shoppingMode ? 2.4 : false
                                        }}
                                    >
                                        <Item
                                            product={product}
                                            onAdd={onAddItem}
                                            onRemove={onRemoveItem}
                                            onView={handleShowDescription}
                                            colorSelected={colorSelected}
                                            shoppingMode={shoppingMode}
                                            refId={selectedRefId}
                                            disabled={existProcessedPayment}
                                        />
                                    </Grid>
                                )
                            }
                            <Box
                                component={Grid}
                                size={12}
                                display='flex'
                                flexDirection='column'
                                alignContent='center'
                                alignItems='center'
                            >
                                <Pagination
                                    color='primary'
                                    page={filters?.page || 1}
                                    onChange={handleChangePage}
                                    count={totalPage}
                                    siblingCount={2}
                                />
                            </Box>
                        </>
                    }
                </Grid>
            }
            {
                !shoppingMode &&
                <FabContainer>
                    <Fab
                        color='primary'
                        variant="extended"
                        className={classes.fab}
                        onClick={handleClickExport}
                    >
                        <GetAppIcon className={classes.extendedIcon} />
                        Descargar catálogo
                    </Fab>
                </FabContainer>
            }
        </>
    );
}

SearchProduct.defaultProps = {
    enableShoppingMode: false
}

SearchProduct.prototype = {
    enableShoppingMode: PropTypes.bool
}

export default SearchProduct;